import rules from './rules.json'

export default () => ({
    rules: rules
});